import { render, staticRenderFns } from "./AddAssetIssuance.vue?vue&type=template&id=38e975c1"
import script from "./AddAssetIssuance.vue?vue&type=script&lang=js"
export * from "./AddAssetIssuance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports